var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBe(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "flag-icons-be",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd",
    strokeWidth: "1pt"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h170.7v512H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffd90c",
    d: "M170.7 0h170.6v512H170.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f31830",
    d: "M341.3 0H512v512H341.3z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBe);
export default __webpack_public_path__ + "static/media/be.5b3a82a296b071e1440a4b997dd4c391.svg";
export { ForwardRef as ReactComponent };